import React, { Fragment } from "react";
import Content from "../common/Content";
import Headline from "../common/Headline";
import Button from "../common/Button";
import FullImageIntro from "../common/FullImageIntro";
import TopBox from "../common/TopBox";
import { RouteName } from "../../lib/routes";
import SliderWithInfo from "../common/SliderWithInfo";
import PressImageItem from "./PressImageItem";
import styled from "styled-components";
import { format } from "date-fns";
import { ApiResult } from "../../lib/CmsApi";
import Label from "../common/Label";
import Grid from "../common/Grid";
import {
  ContactMail,
  ContactNumber
} from "../common/ContactSlider/ContactTile";
import { colors, media, spacing } from "../theme";

import TextTeaserComponent, {
  TextTeaserProps
} from "../common/TextTeaserComponent";
import Section from "../sections/Section";
import { AriaDate } from "../../lib/formatters";
import CustomPageHead from "../common/CustomPageHead";
const StyledHeadline = styled(Headline)`
  ${spacing("margin-bottom", 80)}
`;
const StyledTextTeaserComponent = styled(TextTeaserComponent)<TextTeaserProps>`
  ${spacing("margin-bottom", 80)}
`;

const StyledLabel = styled(Label)`
  color: ${colors.darkgrey};
`;
const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  > * {
    width: 100%;
  }
`;
const GorwOnMobileFlexColumn = styled(FlexColumn)`
  @media screen and ${media.mobile} {
    grid-column: 1/3;
  }
  @media screen and ${media.tiny} {
    grid-column: 1;
  }
`;
export type Props = ApiResult<"listPressReleases"> & ApiResult<"loadPress">;
export default function PressPage(props: Props) {
  const pressImages = props.pressImages.images.filter(
    image =>
      image &&
      image.file &&
      image.file.mimetype &&
      image.file.mimetype.startsWith("image")
  );
  const adressSteps = props.contact.adress.split(/\n/);
  return (
    <Fragment>
      <CustomPageHead
        title={props.name}
        desc={props.header && props.header.intro}
        seo={props.seo}
      />
      <TopBox
        title={props.name || "Presse"}
        breadCrumpPath={[{ title: "Presse", route: "press" as RouteName }]}
        subLinks={[
          { route: "pressArchive" as RouteName, title: "Pressearchiv" }
        ]}
      />
      <main>
        {props.header && props.header.image && (
          <FullImageIntro
            image={props.header.image}
            headline={props.header.headline}
            fallBackAlt={props.header.headline}
            intro={props.header.intro}
          />
        )}
        {props.contact && (
          <Section noTopPadding>
            <Content padded>
              <Headline size={1} level={2}>
                Kontakt
              </Headline>
              <Grid
                columns={3}
                tabletColumns={3}
                mobileColumns={2}
                tinyColumns={1}
              >
                <FlexColumn>
                  <StyledLabel>{props.contact.contact.name}</StyledLabel>
                  <span>{props.contact.role}</span>
                </FlexColumn>
                <FlexColumn>
                  <ContactNumber phone={props.contact.contact.phone} blue />
                  <ContactMail email={props.contact.contact.email} blue />
                </FlexColumn>
                <GorwOnMobileFlexColumn>
                  {adressSteps.map((txt, i) => (
                    <span key={i}>{txt}</span>
                  ))}
                </GorwOnMobileFlexColumn>
              </Grid>
            </Content>
          </Section>
        )}
        {props.items && props.items.length > 0 && (
          <Section noTopPadding>
            <Content padded>
              <StyledHeadline size={1} level={2}>
                Pressemitteilungen
              </StyledHeadline>
              {props.items.map(press => {
                return (
                  <StyledTextTeaserComponent
                    key={press.slug}
                    id={"press_" + press._id}
                    ghost
                    serif
                    layoutType
                    overline={<AriaDate date={press.date} />}
                    headline={press.title}
                    ctaLabel="Weiterlesen"
                    ctaRef={{
                      route: "pressRelease",
                      params: { slug: press.slug }
                    }}
                    text={press.description}
                  />
                );
              })}
              <Button alignCenter route="pressArchive">
                Zum Pressearchiv
              </Button>
            </Content>
          </Section>
        )}

        {props.pressImages && pressImages.length > 0 && (
          <Section color={colors.pigeonSuperLight}>
            <SliderWithInfo
              headline={props.pressImages.headline}
              copy={props.pressImages.intro}
              ariaLabel={props.pressImages.headline || "Pressebilder"}
              padded
            >
              {pressImages.map(image => {
                return (
                  <PressImageItem
                    key={image.file._id}
                    name={image.name}
                    description={image.description}
                    size={image.file.size}
                    image={image.file}
                  />
                );
              })}
            </SliderWithInfo>
          </Section>
        )}
      </main>
    </Fragment>
  );
}

PressPage.getImages = (props: Props) => {
  let images = [];
  if (props.header) images.push(props.header.image);

  if (props.pressImages)
    images = images.concat(props.pressImages.images.map(i => i.file));

  return images;
};
